import JSZip from "jszip";
import { saveAs } from "file-saver";

export const prepareDocumentForZip = async (zip, metaZip, folder, url, metadata, title) => {
    console.log("metadata", metadata, "title", title, "url", url);
    const tempMetadata = {};
    const fullMetadata = JSON.stringify(metadata, null, 2);
    zip.file(folder + "/metadata/" + title + "_fullmetadata.json", fullMetadata);
    metaZip.file(folder + "_metadata/" + title + "_fullmetadata.json", fullMetadata);
    for (const key in metadata) {
        if (!key.startsWith("_") && metadata[key].value) {
            tempMetadata[key] = metadata[key].value;
        }
    }
    const fileContent = JSON.stringify(tempMetadata, null, 2);
    zip.file(folder + "/metadata/" + title + "_metadata.json", fileContent);
    metaZip.file(folder + "_metadata/" + title + "_metadata.json", fileContent);
    const blob = await fetch(url).then(r => r.blob());
    zip.file(folder + "/" + title + "." + metadata.Mimetype?.value.split("/").pop(), blob, { binary: true });
    return {zip, metaZip};
}

export const zipFiles = async (folderName, ...documents) => {
    const counts = {};
    documents = documents.map(doc => {
        counts[doc.title] = (counts[doc.title] || 0) + 1;
        return { ...doc, title: counts[doc.title] > 1 ? doc.title + " (" + counts[doc.title] + ")" : doc.title };
    });
    var zip = new JSZip();
    var metaZip = new JSZip();
    for (const doc of documents) {
        const {zip: tempZip, metaZip: tempMetaZip} = await prepareDocumentForZip(zip, metaZip, folderName, doc.url, doc.metadata, doc.title);
        zip = tempZip;
        metaZip = tempMetaZip;
    };
    zip.file(folderName + "/" + folderName + "_metadata.zip", await metaZip.generateAsync({ type: "blob" }));
    if (documents.length > 1) {
        zip.file(folderName + "/" + folderName + "_filelist.json", JSON.stringify(documents.map(doc => doc.title), null, 2));
    }
    return zip;
}

export const downloadZip = async (zip, title) => {
    zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, title + ".zip");
    });
}